// extracted by extract-css-chunks-webpack-plugin
module.exports = {"BigLoader":"BigLoader_3Xy_c_v16-5-1","BigLoader__Text":"BigLoader__Text_15FS9_v16-5-1","__Before-React-Loaded":"__Before-React-Loaded_2H0-g_v16-5-1"};